import React, { Fragment, useState } from 'react';
import List from "@mui/material/List";
import ListItem from "@mui/material/List";
import Collapse from "@mui/material/Collapse";
import { NavLink } from "react-router-dom";
import logo from '../../images/logo/finale-gattomio-black.jpg.jpeg';
import '../MobileMenu/style.css';

const menus = [
    {
        id: 1,
        title: 'Il mondo Kleeo',
        link: '#',
        submenu: [
            { id: 11, title: 'Scheda tecnica', link: '/kleeo/la-rivoluzione-pulita' },
            { id: 12, title: 'Come funziona', link: '#come-funziona' },
            { id: 13, title: 'Sicurezza', link: '#sicurezza' },
            { id: 14, title: 'Salute e App', link: '#salute-app' },
            { id: 15, title: 'Offerta Lancio', link: '#prezzi' },
        ]
    },
    {
        id: 2,
        title: 'Shop',
        link: '/shop',
    },
    {
        id: 3,
        title: 'Contatti',
        link: '/contact',
    },
]

const MobileMenuLanding = () => {
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => window.scrollTo(10, 0);

    const handleAnchorClick = (anchor) => {
        setMenuState(false);
        setTimeout(() => {
            const el = document.querySelector(anchor);
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 300);
    };

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="mobile-menu-header">
                    <div className="mobile-menu-logo">
                        <img src={logo} alt="logo" />
                    </div>
                    <div className="menu-close">
                        <div className="clox" onClick={() => setMenuState(!menuActive)}><i className="ti-close"></i></div>
                    </div>
                </div>
                <ul className="responsivemenu">
                    {menus.map((item, mn) => (
                        <ListItem className={item.id === openId ? 'active' : null} key={mn}>
                            {item.submenu ? (
                                <Fragment>
                                    <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                        {item.title}
                                        <i className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}></i>
                                    </p>
                                    <Collapse in={item.id === openId} timeout="auto" unmountOnExit>
                                        <List className="subMenu">
                                            <Fragment>
                                                {item.submenu.map((submenu, i) => (
                                                    <ListItem key={i}>
                                                        {submenu.link.startsWith('#') ? (
                                                            <a
                                                                className="active"
                                                                href={submenu.link}
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    handleAnchorClick(submenu.link);
                                                                }}
                                                            >
                                                                {submenu.title}
                                                            </a>
                                                        ) : (
                                                            <NavLink onClick={ClickHandler} className="active" to={submenu.link}>
                                                                {submenu.title}
                                                            </NavLink>
                                                        )}
                                                    </ListItem>
                                                ))}
                                            </Fragment>
                                        </List>
                                    </Collapse>
                                </Fragment>
                            ) : (
                                <NavLink className="active" to={item.link}>{item.title}</NavLink>
                            )}
                        </ListItem>
                    ))}
                </ul>
            </div>
            <div className="showmenu mobail-menu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    )
}

export default MobileMenuLanding;
